import React from 'react';
import { Helmet } from 'react-helmet-async';
import { bloodTests } from '../data/bloodTests';

export default function BloodTests() {
  return (
    <>
      <Helmet defer={false}>
        <title>Home Hormone Blood Tests | Hormonely</title>
        <meta name="description" content="Home hormone blood tests from Medichecks. Finger-prick sample, posted back, results in 48 hours. Hormonely readers receive 10% off all panels." />
      </Helmet>

      <div className="page-hero">
        <div className="container page-hero__inner">
          <div className="eyebrow" style={{ color: 'var(--clay-lt)', marginBottom: '16px' }}>Blood Tests</div>
          <h1 className="page-hero__title">Know before you <em>guess</em></h1>
          <p className="page-hero__sub">Test before you supplement or seek treatment. Every panel below is available at home — finger-prick sample, posted back, results in 48 hours. Hormonely readers receive 10% off.</p>
        </div>
      </div>

      <section className="section section--white">
        <div className="container">
          <div style={{ maxWidth: '720px', marginBottom: '64px' }}>
            <div className="rule"></div>
            <h2 style={{ fontFamily: 'var(--serif)', fontSize: '24px', color: 'var(--bark)', marginBottom: '14px' }}>Why test at home?</h2>
            <p style={{ fontSize: '16px', lineHeight: 1.75, color: '#4a3f36', marginBottom: '14px' }}>
              A standard GP appointment rarely includes a full hormone panel. NHS testing typically covers TSH for thyroid and total testosterone for men — missing free testosterone, oestrogen, progesterone, FSH, LH and other markers that provide a complete picture.
            </p>
            <p style={{ fontSize: '16px', lineHeight: 1.75, color: '#4a3f36', marginBottom: '14px' }}>
              A home blood test gives you actual numbers before you go to your GP — so instead of describing how you feel, you can show what your hormones are doing. This changes the conversation.
            </p>
            <p style={{ fontSize: '16px', lineHeight: 1.75, color: '#4a3f36' }}>
              All panels below are from Medichecks, the UK's leading home blood testing service. Hormonely readers receive 10% off via our affiliate link.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
            {bloodTests.map((t, i) => (
              <div key={i} style={{
                background: 'var(--warm)',
                border: '1px solid rgba(44,34,24,0.08)',
                borderRadius: 'var(--radius)',
                padding: '28px 24px',
              }}>
                <div style={{ fontFamily: 'var(--serif)', fontSize: '28px', color: 'var(--clay)', marginBottom: '10px' }}>{t.price}</div>
                <div style={{ fontSize: '16px', fontWeight: 600, color: 'var(--bark)', marginBottom: '6px' }}>{t.name}</div>
                <div style={{ fontSize: '13px', color: 'var(--stone)', marginBottom: '12px' }}>{t.desc}</div>
                <div style={{ fontSize: '12px', color: 'var(--sage)', fontWeight: 500, marginBottom: '20px', lineHeight: 1.4 }}>
                  Best for: {t.best}
                </div>
                <a
                  href={t.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-clay"
                  style={{ display: 'block', textAlign: 'center', fontSize: '13px' }}
                >
                  Order from Medichecks — 10% off
                </a>
              </div>
            ))}
          </div>

          <div style={{
            marginTop: '48px',
            padding: '24px',
            background: 'rgba(196,120,90,0.07)',
            border: '1px solid rgba(196,120,90,0.15)',
            borderRadius: 'var(--radius)',
            maxWidth: '720px',
          }}>
            <div className="eyebrow" style={{ marginBottom: '10px' }}>Important notes on testing</div>
            <p style={{ fontSize: '14px', lineHeight: 1.65, color: '#4a3f36', marginBottom: '10px' }}>
              <strong>Timing matters for women:</strong> If you are still menstruating, day 2–5 of your cycle gives the most useful oestrogen and FSH picture. Progesterone is best tested around day 21 of a 28-day cycle.
            </p>
            <p style={{ fontSize: '14px', lineHeight: 1.65, color: '#4a3f36', marginBottom: '10px' }}>
              <strong>Perimenopause and normal results:</strong> Hormone levels fluctuate significantly during perimenopause. A single test can appear normal even with active symptoms. If your result comes back normal and you still have symptoms, a repeat test or clinical assessment is worth pursuing.
            </p>
            <p style={{ fontSize: '14px', lineHeight: 1.65, color: '#4a3f36', marginBottom: '0' }}>
              <strong>Take results to your GP:</strong> Home test results are not a diagnosis. Take your results to your GP or a specialist to discuss what they mean in the context of your symptoms and history.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
